
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.456 18.004c-.802 0-1.452-.65-1.452-1.451V1.456C.004.654.654.004 1.456.004h2.322c.802 0 1.452.65 1.452 1.452v15.097c0 .801-.65 1.451-1.452 1.451zm.29-1.742h1.742V1.746H1.746zm6.097 1.742c-.802 0-1.452-.65-1.452-1.451v-8.13c0-.801.65-1.45 1.452-1.45h2.322a1.45 1.45 0 011.452 1.45v8.13c0 .801-.65 1.451-1.452 1.451zm.29-1.742h1.742V8.714H8.133zm6.097 1.742c-.802 0-1.452-.65-1.452-1.451V4.94c0-.802.65-1.452 1.452-1.452h2.322c.802 0 1.452.65 1.452 1.452v11.613c0 .801-.65 1.451-1.452 1.451zm.29-1.742h1.742V5.23H14.52z","clip-rule":"evenodd"}})])
          )
        }
      }
    